<template>
  <div class="bg-white text-center">
    <div class="component-header">
      <h2>Frequently Asked Questions</h2>
      <p class="paragraph">
        Here are the most common questions we receive from educators.
      </p>
    </div>

    <div class="q-pa-md expansion-card">
      <div class="expansion-card-list" role="region" aria-label="Frequently Asked Questions">
        <q-expansion-item
          v-for="(question, index) in questions"
          :key="index"
          :name="index"
          :label="question.label"
          header-class="text-primary"
          class="expansion-card-item"
          expand-icon="add"
          expanded-icon="remove"
        >
          <q-card>
            <q-card-section class="custom-card-section text-body1">
              {{ question.description }}
            </q-card-section>
          </q-card>
        </q-expansion-item>
      </div>
    </div>
  </div>
</template>

<script setup>
defineOptions({
  name: "QuestionsBanner",
});

const questions = [
  {
    id: 1,
    label: "How are schools integrating ChartFlow into their curriculum?",
    description:
      "ChartFlow is typically implemented into Simulation, Skills Labs, Clinical Assignments, Classroom Activities, Lectures, and more.\
      Educators are able to make a patient chart available for case study review, patient prioritization assignments, assessement practice, \
      OSCE's, and SOAP Notes We provide training & onboarding for all educators — contact our team to learn more.",
  },
  {
    id: 2,
    label: "Does ChartFlow's MAR support barcode scanning for medication administration practice?",
    description:
      "ChartFlow does include a realistic eMAR with support for medication administration and barcode scanning. You can easily print off \
       barcodes directly in our platform or use 3rd party Wallcur Practi-Meds or Pocket Nurse Demo Dose medications. For the scanner, you can \
       either use any USB / bluetooth scanner OR access a feature directly in our platform that will access your device's camera allowing your \
        students to practice scanning medications with their phone or tablet",
  },
  {
    id: 3,
    label:
      "Is ChartFlow's EHR affordable?",
    description:
      "Yes, ChartFlow is affordable for all programs, starting from $15 per student! You can find all of our per student pricing options by scrolling up on this page. Licenses can be either purchased as a School on behalf of students or by enabling student to purchase their own access online through our website or through the school bookstore. For more information contact sales@chartflow.io.",
  },
  {
    id: 4,
    label: "Is ChartFlow mobile-friendly and compatible with tablets and Chromebooks?",
    description:
      "ChartFlow is web-based and works on any device with a modern web-browser and internet connection. This includes desktops, laptops, tablets, phones, Chromebooks, Computers-on-Wheels (COWs), projectors, and more. Feel free to create an instructor demo account to see how our platform works today.",
  },
  {
    id: 5,
    label: "What support and training resources are provided?",
    description:
      "ChartFlow provides 24 hour support via text and email for all users. We have a dedicated Help Site that you can access by visiting help.chartflow.io. For instructors and educators, we provide onboarding & training over Zoom. For more information, please contact our team below.",
  },
];
</script>
<style scoped>
.expansion-card {
  display: flex;
  justify-content: center;
}
.expansion-card-list {
  width: 100%;
  text-align: left;
}

.expansion-card-item {
  font-size: 24px;
  font-weight: 600;
  padding: 15px 0;
}

.expansion-card-item:not(:last-child) {
  border-bottom: 1px solid #e7e7ea;
}

.expansion-card-item:hover {
  background-color: unset;
}

.sr-only {
  position: absolute !important;
  width: 1px !important;
  height: 1px !important;
  padding: 0 !important;
  margin: -1px !important;
  overflow: hidden !important;
  clip: rect(0, 0, 0, 0) !important;
  white-space: nowrap !important;
  border: 0 !important;
}

</style>
